import { render, staticRenderFns } from "./VyPager.vue?vue&type=template&id=6ee78d6d&scoped=true&"
import script from "./VyPager.vue?vue&type=script&lang=js&"
export * from "./VyPager.vue?vue&type=script&lang=js&"
import style0 from "./VyPager.vue?vue&type=style&index=0&id=6ee78d6d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee78d6d",
  null
  
)

export default component.exports